module.exports = __webpack_public_path__ + "static/assassin_bug-4b25c33ce1f47ef3fd17e96a97b586ad.jpeg";